import soundManager from './soundManagerClass';

export function sounds(scene)
{
    const sounds = new soundManager(scene);

    const bgMusic = sounds.createTrack("bgMusic");
    const userEffect = sounds.createTrack("userEffect");
    const gameEffect = sounds.createTrack("gameEffect");
    const vo = sounds.createTrack("vo");

    sounds.soundLib.set('jingle-same-different',bgMusic);

    sounds.soundLib.set('click-select-donuts',userEffect);

    sounds.soundLib.set('title-donut-leave',gameEffect);
    sounds.soundLib.set('correct-answer',gameEffect);
    sounds.soundLib.set('different-letters-rise',gameEffect);
    sounds.soundLib.set('&-appear',gameEffect);
    sounds.soundLib.set('donuts-enter-leave',gameEffect);
    sounds.soundLib.set('play-button-pop-up',gameEffect);
    sounds.soundLib.set('incorrect_answer',gameEffect);
    sounds.soundLib.set('title-donut-enter',gameEffect);
    sounds.soundLib.set('same-letters-fall',gameEffect);
    sounds.soundLib.set('sprinkle-fall',gameEffect);
    sounds.soundLib.set('eat-donut',gameEffect);
    sounds.soundLib.set('colors-tween-in',gameEffect);
    sounds.soundLib.set('colors-tween-out',gameEffect);

    sounds.soundLib.set('different-color1',vo);
    sounds.soundLib.set('different-color2',vo);
    sounds.soundLib.set('different-shape1',vo);
    sounds.soundLib.set('different-shape2',vo);
    sounds.soundLib.set('different-shape-color1',vo);
    sounds.soundLib.set('different-shape-color2',vo);
    sounds.soundLib.set('donut-yummy-eat-up',vo);
    sounds.soundLib.set('great-job',vo);
    sounds.soundLib.set('hungry-make-donut',vo);
    sounds.soundLib.set('same-shape-2',vo);
    sounds.soundLib.set('choose-donut-shape',vo);
    sounds.soundLib.set('click-eat-up',vo);
    sounds.soundLib.set('make-another-donut',vo);
    sounds.soundLib.set('pick-frosting-color',vo);
    sounds.soundLib.set('pick-sprinkle-color',vo);
    sounds.soundLib.set('pick-sprinkle-shape',vo);
    sounds.soundLib.set('play-again',vo);
    sounds.soundLib.set('same-color1',vo);
    sounds.soundLib.set('same-color2',vo);
    sounds.soundLib.set('same-different',vo);
    sounds.soundLib.set('same-shape-1',vo);
    sounds.soundLib.set('same-shape-2',vo);
    sounds.soundLib.set('same-shape-color1',vo);
    sounds.soundLib.set('same-shape-color2',vo);
    sounds.soundLib.set('yum',vo);

    return sounds;
}